import React from 'react'
import {
  ExtensionRequestListItem,
  formatExtensionEstimatedTime,
  formatExtensionSubmittedAt,
} from './extensionRequestUtils'

const rowIconStyle = {fontSize: '12px'} as const

function ExtensionDetailRow({
  iconClass,
  label,
  value,
}: {
  iconClass: string
  label: string
  value: React.ReactNode
}) {
  return (
    <span className='d-flex mb-2'>
      <i className={`${iconClass} me-2 text-muted align-self-center`} style={rowIconStyle} />
      <span className='me-2 fw-bold'>{label}</span>
      <span>{value}</span>
    </span>
  )
}

export const MeetingSummaryExtensionsCard: React.FC<{
  extensions: ExtensionRequestListItem[]
  loading?: boolean
}> = ({extensions, loading}) => (
  <div className='card border rounded p-3'>
    <div className='fw-bold mb-3'>Extensions</div>
    {loading && extensions.length === 0 ? (
      <span className='text-muted small'>Loading extension requests…</span>
    ) : extensions.length === 0 ? (
      <span className='text-muted small'>No extension requests</span>
    ) : (
      <div className='d-flex flex-column gap-3'>
        {extensions.map((item, index) => (
          <div
            key={item.id}
            className='border rounded p-3 bg-light-subtle'
            data-testid={`extension-request-${item.id}`}
          >
            <div className='fw-semibold mb-2'>
              Extension {extensions.length > 1 ? `#${index + 1}` : ''}
              {item.id ? ` (ID ${item.id})` : ''}
            </div>
            <ExtensionDetailRow
              iconClass='fa-solid fa-user'
              label='Staff:'
              value={
                item.staffName
                  ? `${item.staffName}${item.staffEmail ? ` (${item.staffEmail})` : ''}`
                  : item.staffEmail || '-'
              }
            />
            {item.staffNumber ? (
              <ExtensionDetailRow
                iconClass='fa-solid fa-phone'
                label='Staff number:'
                value={item.staffNumber}
              />
            ) : null}
            <ExtensionDetailRow
              iconClass='fa-solid fa-comment'
              label='Reason:'
              value={item.reason || '-'}
            />
            <ExtensionDetailRow
              iconClass='fa-solid fa-hourglass-half'
              label='Estimated extension:'
              value={formatExtensionEstimatedTime(item.estimatedTime)}
            />
            <ExtensionDetailRow
              iconClass='fa-solid fa-calendar'
              label='Submitted:'
              value={formatExtensionSubmittedAt(item.submittedAt)}
            />
            {item.submittedBy ? (
              <ExtensionDetailRow
                iconClass='fa-solid fa-user-pen'
                label='Submitted by:'
                value={item.submittedBy}
              />
            ) : null}
          </div>
        ))}
      </div>
    )}
  </div>
)
